module.exports = __webpack_public_path__ + "img/UI_SSL_yuanbao_04_93dcd4094.png";